// Actions
// export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
// export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
// export const GET_APPLICATION_LIST = "GET_APPLICATION_LIST";
export const SET_DATA_PREV_PAGE = "SET_DATA_PREV_PAGE";
